import React from "react";
import {
  Checkbox as UiCheckbox,
  CheckboxProps as UiCheckboxProps,
  Text,
  TextProps
} from "@chakra-ui/react";
import { generateId, useField } from "duck";
import { Types } from "../../duck";
import InputLayout from "../input-layout";

export interface CheckboxProps
  extends Omit<UiCheckboxProps, "name">,
    Types.BaseInputProps {
  layoutLabel?: string;
  layoutLabelHidden?: boolean;
  labelProps?: TextProps;
}

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  label,
  labelProps,
  inputLayoutProps,
  layoutLabel,
  layoutLabelHidden = true,
  ...rest
}) => {
  const labelId = React.useMemo(() => name || generateId(), [name]);
  const { onChange, value, error } = useField(name);

  return (
    <InputLayout
      id={labelId}
      label={layoutLabel}
      labelHidden={layoutLabelHidden}
      errorMessage={error}
      input={
        <UiCheckbox
          onChange={onChange}
          name={labelId}
          value={value}
          spacing={4}
          {...rest}
        >
          <Text
            color="gray.700"
            fontSize={rest.fontSize || "md"}
            {...labelProps}
          >
            {label}
          </Text>
        </UiCheckbox>
      }
      {...inputLayoutProps}
    />
  );
};

export default Checkbox;
